import useGet from "../read/useGet";

const useGetEmployeeGratuityList = () => {
  const { list: getListReq, setGetListParams } = useGet({
    url: "fetch_gratuity_employee_list",
    initialData: {
      page_number: 0,
      limit: 10,
      search_query: "",
    },
  });
  const gratuityList = getListReq?.data?.data || [];
  const isLoading = getListReq.isLoading;
  const paginationData = {
    page_no: getListReq?.data?.page_no || 0,
    per_page: getListReq?.data?.limit || 10,
    total_count: getListReq?.data?.total_count || 0,
  };

  const onPageChange = (selected) => {
    setGetListParams((prev) => ({
      ...prev,
      page_number: selected.selected,
    }));
  };

  return {
    gratuityList,
    isLoading,
    paginationData,
    onPageChange,
    setGetListParams,
  };
};

export default useGetEmployeeGratuityList;
